export enum ShopsFilterSectionEnum {
  type = 'TYPE_CENTER',
  services = 'SERVICES',
  autoservices = 'AUTOSERVICES',
  // goods = "GOODS",
}

export const ShopsFilterName: { [index: string]: string } = {
  [ShopsFilterSectionEnum.type]: 'Тип центра',
  [ShopsFilterSectionEnum.services]: 'Услуги',
  [ShopsFilterSectionEnum.autoservices]: 'Автосервис',
  // [ShopsFilterSectionEnum.goods]: "Товары",
};

export const ShopsFilterNameTwo = (value: string) => {
  switch (value) {
    case 'type_center':
      return 'Тип центра';
    case 'services':
      return 'Услуги';
    case 'autoservices':
      return 'Автосервис';
    default:
  }
};

export const TopFilter = [
  {
    id: 1,
    title: 'Шиномонтаж сегодня/завтра',
    shortName: 'Есть запись',
    visible: false,
    checked: false,
  },
  {
    id: 2,
    title: 'Показать ближайшие центры',
    shortName: 'Ближайшие',
    visible: false,
    checked: false,
  },
  {
    id: 3,
    title: 'Для корпоративных клиентов',
    shortName: 'Для корпоративных клиентов',
    visible: false,
    checked: false,
  },
];

export const listPartners = ['«5 Колесо»', '«Мой автомобиль»', 'Партнерский центр', 'Пункт выдачи'];

export const ProductList = [
  {
    title: 'Шины',
    textLink: 'Подобрать шины',
    href: '/catalog/filter/tyres/',
    image: 'tyres',
  },
  {
    title: 'Диски',
    textLink: 'Подобрать диски',
    href: '/catalog/filter/discs/',
    image: 'discs',
  },
  {
    title: 'Аккумуляторы',
    textLink: 'Подобрать аккумуляторы',
    href: '/catalog/filter/accumulators/',
    image: 'accumulators',
  },
  {
    title: 'Автотовары',
    textLink: 'Подобрать aвтотовары',
    href: '/catalog/filter/',
    image: 'group',
  },
];

export const lightList = ['avtomoyka', 'post', 'avtoservice'];

export const listBlockService = {
  Service: 1,
  Product: 2,
  Actions: 3,
  Reviews: 4,
  Map: 5,
};

export enum ServicesName {
  post = 'Количество постов',
  shops = 'Магазин',
  avtoservice = 'Автосервис',
  shinomontazh = 'Шиномонтаж',
  avtomoyka = 'Автомойка',
  tradein = 'Трейд-ин',
  shop = 'Магазин',
  cx = 'Сезонное хранение',
}
